const state = {
    jobQualification: {
        gender: "",
        age_range: "",
        study_fields: [],
        languages: [],
        courses: [],
        related_softwares: [],

        required_experience: {
            years_experience: null,
            related_experience: null,
        },
        career_path: "",
        equipments: [],
        physical_traits: [],
        work_time: "",
        work_area: ""
    },
};

const mutations = {
    setJobQualification(state, value) {
        state.jobQualification = value;
    },
    updateJobQualificationProperty(state, { property, value }) {
        state.jobQualification[property] = value;
    },
};

const actions = {};

const getters = {
    jobQualification: state => state.jobQualification,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
